import { create } from 'zustand';

interface ConfigurationStore {
  periodeConsultee: { mois: number; annee: number };
  setPeriode: (mois: number, annee: number) => void;
}

const now = new Date();
export const useConfigurationStore = create<ConfigurationStore>((set) => ({
  periodeConsultee: { mois: now.getMonth() + 1, annee: now.getFullYear() },
  setPeriode: (mois, annee) => set({ periodeConsultee: { mois, annee } }),
}));
